import * as IconMUI from '@mui/icons-material';
import { Box } from '@mui/material';
import { FC } from 'react';

import styles from './styles.module.scss';
import { IconProps } from './types';

const Icon: FC<IconProps> = ({ name, color = "primary", height = "1rem", width = "1rem", onClick, background, className = "", sx, disabled }) => {
    const Icons = IconMUI as any;
    const Component = Icons[name];
    return (
        <Box className={`${styles.Icon} ${className} ${disabled ? styles.disabled : ''}`} onClick={disabled ? undefined : onClick} sx={[{
            cursor: onClick ? 'pointer' : 'inherit', background: background || 'none',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
        ]} >
            {Component && <Component style={{ height: height, width: width, color: color }} />}
        </Box>
    )
}

export default Icon